export type CreateDeviceTab = "identity" | "placement";

export const CREATE_DEVICE_TAB_LABELS: Record<CreateDeviceTab, string> = {
  identity: "Identity",
  placement: "Placement",
};

export type PlacementOption = {
  value: string;
  label: string;
};

export const NONE_VALUE = "";

export function validateCreateDeviceFields(input: {
  name: string;
}): { ok: true } | { ok: false; tab: CreateDeviceTab; nameError: string } {
  if (input.name.trim().length < 1) {
    return { ok: false, tab: "identity", nameError: "Name is required" };
  }
  return { ok: true };
}

export function buildCreateDevicePayload(input: {
  name: string;
  deviceType: string;
  location: string;
  organization: string;
  assignedTo: string;
  notes: string;
}) {
  return {
    name: input.name.trim(),
    deviceType: input.deviceType,
    location: input.location.trim() || undefined,
    organization: input.organization.trim() || undefined,
    assignedTo: input.assignedTo.trim() || undefined,
    notes: input.notes.trim() || undefined,
  };
}

export function uniqueSortedStrings(values: Array<string | null | undefined>): string[] {
  const set = new Set<string>();
  for (const value of values) {
    const trimmed = value?.trim();
    if (trimmed) set.add(trimmed);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

export function accountAssignmentLabel(account: {
  firstName: string;
  lastName: string;
  email: string;
}): string {
  const name = [account.firstName, account.lastName].filter(Boolean).join(" ").trim();
  return name ? `${name} (${account.email})` : account.email;
}

export function accountAssignmentValue(account: {
  firstName: string;
  lastName: string;
  email: string;
}): string {
  const name = [account.firstName, account.lastName].filter(Boolean).join(" ").trim();
  return name || account.email;
}
